import { useCallback, useEffect, useRef, useState } from "react";
import { Avatar, Box, Button, Typography } from "@mui/material";
import { useLegajosContext } from "../../../../context/LegajoTabsContext";
import { CloudUpload, Delete, Person } from "@mui/icons-material";
import { useFileUpload } from "../../../../../../Hooks/useUploadFiles";
import { useDocuments } from "../../../../../mant_plantas/hooks/useDocuments";
import { getFotoEmpleado } from "../../services/empleados.api";
import { UrlApi } from "../../../../../../services/apirest";
import { logEventos } from "../../../../../../services/services";
import axios from "axios";

export default function FotoForm({ isEditing, cuil }) {
  const { formData, ensureUuidFoto } = useLegajosContext();
  const [file, setFile] = useState(null);
  const [imageSrc, setImageSrc] = useState("");
  const uuidFoto = formData?.datosPersonales?.uuid_foto || "";
  const user = localStorage.getItem("user");
  const fileInputRef = useRef(null);
  const { isUploading, uploadProgress, uploadError, uploadFile } =
    useFileUpload();
  const { removeDocument } = useDocuments();
  // Cargar archivo inicial si existe el empleado
  useEffect(() => {
    const getFileEmp = async () => {
      if (cuil) {
        try {
          const data = await getFotoEmpleado(cuil);
          
          setFile(data);
        } catch (error) {
          console.error("Error al cargar foto:", error);
          setFile(null);
        }
      } 
    };
    getFileEmp();
  }, [cuil]);
  const fetchArchivos = useCallback(async () => {
    if (!uuidFoto) return null;
    try {
      const { data } = await axios.get(`${UrlApi}/uploadfiles/todownload/${uuidFoto}`);
      setFile(data);
      return data;
    } catch (error) {
      console.error("Error fetching archivos:", error);
      return null;
    }
  }, [uuidFoto]);

  // Asegurar UUID al montar si estamos en alta
  useEffect(() => {
    if (!cuil && !uuidFoto) {
      ensureUuidFoto();
    }
  }, [cuil, uuidFoto, ensureUuidFoto]);
  useEffect(() => {
if(!cuil){
    fetchArchivos();
}
  }, [fetchArchivos,cuil]);
  // Cargar imagenSrc
  const fetchImage = async () => {
    const archivo = file[0];

    // Verificar que archivo existe y tiene las propiedades necesarias
    if (!archivo || !archivo.id_archivo || !archivo.nombre) {
      setImageSrc("");
      return;
    }
    try {
      const response = await fetch(
        `${UrlApi}/uploadfiles/uploads/${archivo?.id_archivo}-${archivo?.nombre}`
      );

      if (!response.ok) {
        throw new Error("Error al cargar la imagen");
      }

      const blob = await response.blob();
      setImageSrc(URL.createObjectURL(blob));
    } catch (error) {
      console.error("Error al cargar imagen:", error);
      setImageSrc("");
    }
  };

  useEffect(() => {
    fetchImage();

    // Cleanup: liberar la URL del objeto cuando el componente se desmonte
    return () => {
      if (imageSrc) {
        URL.revokeObjectURL(imageSrc);
      }
    };
  }, [file]); // Solo depende de file

  const handleChangeFile = async (e) => {
    const selectedFile = e.target.files[0];

    // Validar tamaño (5MB máximo)
    if (selectedFile.size > 5 * 1024 * 1024) {
      alert("El archivo no debe superar los 5MB");
      return;
    }

    try {
      // Pasar el archivo en un array como espera useFileUpload
      const result = await uploadFile([selectedFile], uuidFoto);

      if (result?.status) {
        // Refrescar la foto después de la subida
        if (cuil) {
          const data = await getFotoEmpleado(cuil);
          setFile(data);
        } else {
          const data = await fetchArchivos();
          setFile(data);
        }
        logEventos("Foto de empleado subida", "Legajos", "subir archivo", user);
        await fetchImage();
      }
    } catch (error) {
      console.error("Error al subir archivo:", error);
      logEventos("Error al subir archivo", "Legajos", "subir archivo", user);
    }

    // Limpiar el input para permitir subir el mismo archivo de nuevo
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleDeletePhoto = async () => {
    try {
      const fileCero = file[0];
      await removeDocument(fileCero.id, fileCero);
      setFile(null);
      setImageSrc("");
    } catch (error) {
      console.error("Error al eliminar foto:", error);
      logEventos("Error al eliminar foto", "Legajos", "eliminar foto", user);
    }
  };

  return (
    <Box
      sx={{

        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      {imageSrc ? (
        <Box sx={{ textAlign: "center" }}>
          <Avatar
            src={imageSrc}
            alt="Foto del empleado"
            sx={{ width: 160, height: 160, mb: 3, boxShadow: 3 }}
          />
          <Button
            variant="outlined"
            color="error"
            startIcon={<Delete />}
            onClick={handleDeletePhoto}
            disabled={isUploading || isEditing}
          >
            Eliminar Foto
          </Button>
        </Box>
      ) : (
        <Box sx={{ textAlign: "center", py: 4 }}>
          <Avatar
            sx={{
              width: 160,
              height: 160,
              mb: 3,
              bgcolor: "grey.300",
              mx: "auto",
            }}
          >
            <Person sx={{ fontSize: 80 }} />
          </Avatar>
          <Button
            variant="contained"
            component="label"
            startIcon={<CloudUpload />}
            disabled={isUploading || isEditing || (!cuil && !uuidFoto)}
          >
            {isUploading
              ? `Subiendo... ${uploadProgress}%`
              : "Seleccionar Foto"}
            <input
              type="file"
              ref={fileInputRef}
              hidden
              accept="image/*"
              onChange={handleChangeFile}
            />
          </Button>
          <Typography
            variant="caption"
            display="block"
            sx={{ mt: 2, color: "text.secondary" }}
          >
            JPG, PNG o GIF. Máximo 5MB
          </Typography>
          {uploadError && (
            <Typography
              color="error"
              variant="caption"
              display="block"
              sx={{ mt: 1 }}
            >
              {uploadError}
            </Typography>
          )}
        </Box>
      )}
    </Box>
  );
}
